import { jsx as _jsx } from "react/jsx-runtime";
import { BaseEdge, getBezierPath } from '@xyflow/react';
import { DARK_GREY_HEX, HIGHLIGHT_HEX } from '../../../constants';
/**
 * Component renders "default" type of connection of ReactFlow.
 * @param props : props come from ReactFlow.
 * See RF_EDGE_TYPES.
 */
const RFDefaultEdgeFC = ({ sourceX, sourceY, targetX, targetY, selected, markerEnd, sourcePosition, targetPosition, style = {} }) => {
    const [edgePath] = getBezierPath({
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourcePosition,
        targetPosition
    });
    return (_jsx(BaseEdge, { path: edgePath, markerEnd: markerEnd, style: { ...style, stroke: selected ? HIGHLIGHT_HEX : DARK_GREY_HEX, strokeWidth: 1 } }));
};
export const RFDefaultEdge = RFDefaultEdgeFC;
//# sourceMappingURL=RFDefaultEdge.js.map